"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var token_1 = __importDefault(require("markdown-it/lib/token"));

function isParagraph(token) {
  return token.type === "paragraph_open";
}

function isInline(token) {
  return token.type === "inline" && token.level === 1;
}

function isLinkOpen(token) {
  return token.type === "link_open";
}

function isLinkClose(token) {
  return token.type === "link_close";
}

function default_1(embeds) {
  function isEmbed(token, link) {
    var href = link.attrs ? link.attrs[0][1] : "";
    var simpleLink = href === token.content;
    if (!simpleLink) return false;
    if (!embeds) return false;

    var _iterator = _createForOfIteratorHelper(embeds),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var embed = _step.value;
        var matches = embed.matcher(href);

        if (matches) {
          return Object.assign(Object.assign({}, embed), {
            matches: matches
          });
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return function markdownEmbeds(md) {
    md.core.ruler.after("inline", "embeds", function (state) {
      var tokens = state.tokens;
      var insideLink;

      for (var i = 0; i < tokens.length - 1; i++) {
        if (isInline(tokens[i]) && isParagraph(tokens[i - 1])) {
          var tokenChildren = tokens[i].children || [];

          for (var j = 0; j < tokenChildren.length - 1; j++) {
            var current = tokenChildren[j];
            if (!current) continue;

            if (isLinkOpen(current)) {
              insideLink = current;
              continue;
            }

            if (isLinkClose(current)) {
              insideLink = null;
              continue;
            }

            if (insideLink) {
              var result = isEmbed(current, insideLink);

              if (result) {
                var content = current.content;
                var token = new token_1.default("embed", "iframe", 0);
                token.attrSet("href", content);
                token.attrSet("component", result.component);
                token.attrSet("matches", result.matches);
                tokens.splice(i - 1, 3, token);
                break;
              }
            }
          }
        }
      }

      return false;
    });
  };
}

exports.default = default_1;